// extracted by mini-css-extract-plugin
module.exports = {"paymentForm":"PaymentSidebar_paymentForm__3508P","row":"PaymentSidebar_row__mVjzS","column":"PaymentSidebar_column__Jynx6"};